import { render, staticRenderFns } from "./CommonMeasuresInvoiceBasisForm.vue?vue&type=template&id=8fa130ee&"
import script from "./CommonMeasuresInvoiceBasisForm.vue?vue&type=script&lang=ts&"
export * from "./CommonMeasuresInvoiceBasisForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VOverlay,VProgressCircular,VTooltip})
